/* eslint-disable */
import { useState, useEffect, useRef } from "react";
import { C, t, fmt$, formatDate } from "../shared/globals.js";

function ProfitDonut({ entries, currentPrice }) {
  const [hovered, setHovered] = useState(null); // "profit" | "loss"

  const profit = entries.filter(e => e.shares > 0 && (e.dollars/e.shares) <= currentPrice).length;
  const loss   = entries.length - profit;
  const total  = entries.length || 1;
  const pct    = Math.round((profit / total) * 100);

  const SIZE  = 160;
  const CX    = SIZE / 2;
  const CY    = SIZE / 2;
  const R     = 58;
  const THICK = 16;
  const r2    = R;
  const circ  = 2 * Math.PI * r2;

  const profitArc = (profit / total) * circ;
  const lossArc   = circ - profitArc;

  // SVG arc helpers
  const profitDash = `${profitArc} ${circ}`;
  const lossDash   = `${lossArc} ${circ}`;
  // Loss starts where profit ends
  const lossOffset = -(profitArc);

  const isHovProfit = hovered === "profit";
  const isHovLoss   = hovered === "loss";

  return (
    <div style={{ background:"var(--bg2)", border:"1px solid var(--border)", borderRadius:10,
      padding:"16px 20px", flexShrink:0, width:200, display:"flex", flexDirection:"column",
      alignItems:"center", gap:12, alignSelf:"stretch" }}>

      <div style={{ fontFamily:"Montserrat,sans-serif", fontSize:9, fontWeight:700,
        letterSpacing:"0.3em", color:"var(--text4)", alignSelf:"flex-start" }}>{t("pnlSplit")}</div>

      {/* Donut */}
      <div style={{ position:"relative", width:SIZE, height:SIZE }}>
        <svg width={SIZE} height={SIZE} style={{ transform:"rotate(-90deg)" }}>
          {/* Background track */}
          <circle cx={CX} cy={CY} r={r2} fill="none"
            stroke="var(--border)" strokeWidth={THICK}/>
          {/* Loss arc */}
          <circle cx={CX} cy={CY} r={r2} fill="none"
            stroke={isHovLoss ? C.red : `${C.red}99`}
            strokeWidth={isHovLoss ? THICK + 3 : THICK}
            strokeDasharray={lossDash}
            strokeDashoffset={lossOffset}
            strokeLinecap="round"
            style={{ transition:"all 0.2s", cursor:"default" }}
            onMouseEnter={() => setHovered("loss")}
            onMouseLeave={() => setHovered(null)}
          />
          {/* Profit arc */}
          <circle cx={CX} cy={CY} r={r2} fill="none"
            stroke={isHovProfit ? C.green : C.green}
            strokeWidth={isHovProfit ? THICK + 3 : THICK}
            strokeDasharray={profitDash}
            strokeLinecap="round"
            style={{ transition:"all 0.2s", cursor:"default" }}
            onMouseEnter={() => setHovered("profit")}
            onMouseLeave={() => setHovered(null)}
          />
        </svg>

        {/* Center text */}
        <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column",
          alignItems:"center", justifyContent:"center", pointerEvents:"none" }}>
          <div style={{ fontFamily:"Montserrat,sans-serif", fontSize:28, fontWeight:900,
            color:"var(--text3)",
            lineHeight:1, transition:"color 0.2s" }}>
            {hovered === "loss" ? `${100-pct}%` : `${pct}%`}
          </div>
          <div style={{ fontFamily:"Montserrat,sans-serif", fontSize:8, fontWeight:700,
            letterSpacing:"0.15em",
            color:"var(--text4)",
            marginTop:3, transition:"color 0.2s" }}>
            {hovered === "loss" ? "LOSS" : "PROFIT"}
          </div>
        </div>
      </div>

      {/* Legend */}
      <div style={{ display:"flex", flexDirection:"column", gap:8, width:"100%" }}>
        {[
          { color:C.green, label:"IN PROFIT", count:profit },
          { color:C.red,   label:"UNDERWATER", count:loss   },
        ].map(({color,label,count}) => (
          <div key={label} style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div style={{ display:"flex", alignItems:"center", gap:6 }}>
              <div style={{ width:8, height:8, borderRadius:"50%", background:color }}/>
              <span style={{ fontFamily:"Montserrat,sans-serif", fontSize:9, fontWeight:700,
                color:"var(--text4)", letterSpacing:"0.1em" }}>{label}</span>
            </div>
            <span style={{ fontFamily:"Montserrat,sans-serif", fontSize:12, fontWeight:700,
              color }}>{count}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProfitDonut;
